module.exports = __webpack_public_path__ + "static/media/upload-file.815abe0c.svg";